import React, { useEffect, useState } from 'react';
import { Box } from "@mui/material";
import ProgressTracker from "../../../components/common/ProgressTracker";
import { fetchV2V, selectAllInitialSteps, selectCurrentCycle, selectLocationLoading } from '../../../slices/common';
import { useDispatch, useSelector } from 'react-redux';
import SkeletonLoader from '../../../../utilites/SkeltonLoader';
import { useParams } from 'react-router';
import { getPatientDetailsById } from '../../../slices/QRCode';
import InBoundForm from '../../../../pages/appointment-details/InBoundForm';
import { dateFormater } from '../../../utils/common/utils';
import LmsKitLabel from '../../../components/features/LmsKitLabel';
import {capitalizeWords} from "../../../../utils/utils"

const ApprovedSubjectDetails = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const isLoading = useSelector(selectLocationLoading)
    const [patientInfo, setPatientInfo] = useState({});
    const [patientData, setPatientData] = useState({});
    const [patientMedicalInfo, setPatientMedicalInfo] = useState({});
    const allInitialSteps = useSelector(selectAllInitialSteps)
    const currentCycle = useSelector(selectCurrentCycle)
    const [ids, setIds] = useState(id)

    const fetchPatientInfo = async (id = currentCycle?.qr_code_generation_id) => {
        try {
            if(!id) return
            const patientDetailsResponse = await dispatch(
                getPatientDetailsById({id:id,prodmfg:currentCycle?.product_manufacturing_id})
            ).unwrap();
            const patientDetails = patientDetailsResponse?.data?.patient_information;
            const isBagCount = patientDetailsResponse?.data?.number_of_bags;
            if (patientDetails) {
                const patientBasicInfo = {
                    patientName: patientDetails?.name || "-",
                    patientId: patientDetails?.patient_id || "-",
                    id: patientDetails?.id,
                    product_id:patientDetailsResponse?.data?.product_id,
                    phase_id:patientDetails?.phase_id,
                      hospital_patient_id: patientDetailsResponse?.data?.hospital_patient_id || "",
                    inbond_form_id: patientDetails?.inbound_patient_id ?? null,
                    logisticOperationId: patientDetailsResponse?.data?.logistics_operation_id ?? null,
                    immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
                };
                const patientMedicalRecord = {
                    "Patient Body Weight": `${patientDetails?.body_weight} Kg` || "-",
                    "Disease Indication": capitalizeWords(patientDetails?.disease) || "-",
                    "Date of Birth": patientDetails?.dob
                        ? dateFormater(patientDetails.dob)
                        : "-",
                    "Hospital Name": patientDetails?.hospital || "-",
                    "Hospital Patient ID": patientDetailsResponse?.data?.hospital_patient_id || "-",
                    "Ship & Store": "2-8 degree celsius",
                    "Total no Bags": isBagCount ?? 0,
                    "Batch ID": patientDetailsResponse?.data?.batch_no || "-",
                };
                setPatientData(patientDetailsResponse?.data)
                setPatientInfo(patientBasicInfo);
                setPatientMedicalInfo(patientMedicalRecord);
            }
        } catch (error) {
            console.error("Error fetching patient info:", error);
        }
    };

    useEffect(() => {
     if (currentCycle) {
        setPatientMedicalInfo((prev) => ({
          ...prev,
          "Total no Bags": currentCycle?.no_of_bags || 0,
          "Batch ID": currentCycle?.batch_no
        }));
      }
    }, [currentCycle]);
    // function to get the timeline
    const getTimeLine = async (id) => {
        try {
            await dispatch(
                fetchV2V({ portal_type: 2, patient_id: id })
            ).unwrap();
        }
        catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        patientData?.patient_information?.id && getTimeLine(patientData?.patient_information?.id)
    }, [patientData?.patient_information?.id])

    useEffect(() => {
      if(ids){
    fetchPatientInfo(ids);
    setIds('')
      }
  }, [ids]);
  
  useEffect(() => {
    if(!ids)
      fetchPatientInfo()
  },[currentCycle?.product_manufacturing_id])


    return (
        <Box className="p-3">
            <Box container className="mt-4 ml-3 mr-3 mainDiv">
                <LmsKitLabel
                    screenType="logistics"
                    patientInfo={patientInfo}
                    patientMedicalInfo={patientMedicalInfo}
                    qrCodeId={id}
                />
            </Box>
            <Box container className="mt-4 ml-3 mr-3 pb-3 mainDiv">
                {isLoading ? (
                    <SkeletonLoader rowCount={1} height={80} isTable={false} />
                ) : <ProgressTracker steps={allInitialSteps} patient_id={patientData?.patient_information?.id} />
                }
            </Box>
            <Box className="p-3">
                <InBoundForm
                    patientData={{
                        ...patientData,
                        inbond_form_id: currentCycle?.inbond_patients_id,
                        patient_id: patientData?.patient_information?.id
                    }}
                    initialSteps={allInitialSteps}
                    noQuery={true}
                />
            </Box>
        </Box>
    );
};

export default ApprovedSubjectDetails;